<ng-container *transloco="let convert;">
  <div
    class="card utility-bar"
    id="utility-bar"
    aria-hidden="false"
    [ngClass]="{ 'no-margin': noMargin }"
    >
    @if (isSelectAllEnabled || isAdminSelectAllEnabled) {
      <div class="select-all-checkbox custom-control custom-checkbox border-primary pe-2">
        <input
          id="selectAllCheckbox"
          type="checkbox"
          class="custom-control-input"
          [attr.aria-label]="convert('sellModule.manageInventory.utilityBar.ariaLabelSelectAllVehicle')"
          (change)="toggleSelectAll()"
          [checked]="selectAllChecked"
          [disabled]="disableCheckbox"
          >
        <label for="selectAllCheckbox" class="custom-control-label">
          <span >{{convert('sellModule.manageInventory.utilityBar.textSelectAllVehicle')}}</span>
        </label>
      </div>
    }
    @if (isExportResultsEnabled) {
      <button
    [class]="
      showDateRange
        ? 'btn btn-outline-primary inventory-results-controls__export__offersByDealer'
        : 'btn btn-outline-primary inventory-results-controls__export'
    "
        type="button"
        [style.align-self]="dateRangeError ? 'center' : 'flex-end'"
        [style.margin-bottom]="dateRangeError ? '22px' : ''"
        id="export_results_button"
        [attr.aria-label]="convert('sellModule.manageInventory.utilityBar.arialabelExportResults')"
        [attr.aria-disabled]="isExporting"
        data-track-name="Export Results"
        [disabled]="isExporting"
        data-track-trigger="modal"
        (click)="export()"
        #exportButton
        >
        {{convert('sellModule.manageInventory.utilityBar.arialabelExportResults') | titlecase}}
      </button>
    }
    <div class="utility-bar__mobile-btn-container">
      <button
        data-track-elem="icon"
        data-track-name="Filters"
        data-track-trigger="filter"
        aria-label="convert('sellModule.manageInventory.utilityBar.ariaLabelFilters')"
        class="utility-bar__btn-mobile text-primary"
        (click)="toggleMobileFilter()"
        >
        <i
          aria-hidden="true"
          class="utility-bar__btn-icon me-1 allycon-filter"
        ></i>
        <span class="utility-bar__btn-label"><strong>{{convert('sellModule.manageInventory.utilityBar.ariaLabelFilters')}}</strong></span>
      </button>
    </div>
    @if (showDateRange && !mobileFiltersVisible) {
      <lib-utility-bar-date-range
        dpElNamespace="desktop"
        class="desktop-datepicker"
        (hasDateRangeError)="handleDateRangeError($event)"
      ></lib-utility-bar-date-range>
    }
    <div class="utility-bar__sort ms-auto d-flex flex-row">
      <lib-search-results-sort-select
        id="select-sort-by"
        label="{{convert('sellModule.manageInventory.utilityBar.labelSortBy')}}"
        data-track-region="Sort Drop Down"
        [stacked]="showDateRange"
        >
        <label
          for="select-sort-by"
          class="app-label"
        >{{convert('sellModule.manageInventory.utilityBar.labelSortBy')}}</label>
      </lib-search-results-sort-select>
    </div>

    <div
      class="utility-bar__btn-container"
      [style.margin-top]="dateRangeError ? '19px' : ''"
      [style.margin-bottom]="dateRangeError ? 'auto' : ''"
      >
      @if (!isListView) {
        <button
          data-track-elem="icon"
          data-track-name="collapse"
          class="utility-bar__btn"
          [attr.aria-label]="convert('sellModule.manageInventory.utilityBar.ariaLabelCollapse')"
          (click)="toggleState.close(); isExpanded = false"
          [attr.aria-expanded]="isExpanded"
          >
          <img
            src="../../../ui/assets/assets-{{ tenantName }}/{{ tenantName }}-collapse.svg"
            alt="{{convert('sellModule.manageInventory.utilityBar.ariaLabelCollapse')}}"
            />
        </button>
      }

      @if (!isListView) {
        <button
          data-track-elem="icon"
          data-track-name="expand"
          class="utility-bar__btn"
          [attr.aria-label]="convert('sellModule.manageInventory.utilityBar.ariaLabelExpandVehicle')"
          (click)="toggleState.open(); isExpanded = true"
          [attr.aria-expanded]="isExpanded"
          >
          <img
            src="/ui/assets/assets-{{ tenantName }}/{{ tenantName }}-expand.svg"
            alt="{{convert('sellModule.manageInventory.utilityBar.ariaLabelShowVehicle')}}"
            />
        </button>
      }
    </div>
  </div>

  <trap-focus
    [enableFocusTrap]="true"
    [enableArrowKeys]="true"
    >
    @if (mobileFiltersVisible) {
      <lib-mobile-search-filter
        (closed)="toggleMobileFilter()"
        [showDateRange]="showSellActiveDateRange"
      ></lib-mobile-search-filter>
    }
  </trap-focus>
</ng-container>
